import styled, { css } from 'styled-components';
import { FontSize } from './units';

import { Spacing } from './units';

import GoogleImg from '../assets/google-logo.svg';
import Error from '../assets/error.svg';
import Radio from '../assets/radiobutton.svg';
import RadioActive from '../assets/radiobutton_active.svg';

export const Backdrop = styled.div`
    pointer-events: none;
    background: #fff;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Title = styled.div`
    font-size: ${FontSize.xxx_large};
    font-weight: 500;
    line-height: 125%;
    text-align: center;
`;

export const Button = styled.button`
    box-sizing: border-box;
    display: inline-block;
    border: 1.5px solid;
    border-radius: 30px;

    font-family: 'Noto Sans', 'Open Sans', 'Helvetica Neue', 'Helvetica', sans-serif;
    font-size: ${FontSize.x_large};
    text-align: center;
    font-weight: 500;
    line-height: 125%;
    text-decoration: none;
    cursor: pointer;

    padding: 12.5px 32px;
    outline: none;
    width: 100%;

    background: #4970ff;
    border-color: #4970ff;
    color: #fff;

    &:hover {
        background: #3059f0;
        border-color: #3059f0;
    }

    &:active {
        background: #2046d1;
        border-color: #2046d1;
    }
`;

export const FormControl = styled.div<{ required?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${Spacing.x_small};

    &:disabled {
        opacity: 0.5;
    }

    & > label {
        color: #676d82;
        line-height: 150%;
    }

    ${({ required }) =>
        required &&
        css`
            > label::after {
                content: '*';
                color: red;
                padding-left: 3px;
            }
        `}
`;

export const Input = styled.input<{ error?: boolean }>`
    box-sizing: border-box;
    border: 1px solid #9297a6;
    border-radius: 2px;
    outline: none;

    height: 60px;
    width: 100%;
    padding: 15px 16px;
    line-height: 30px;

    font-size: ${18 / 16}rem;

    ${({ error }) =>
        error &&
        css`
            border-color: #f25b3a;
        `}

    &:hover {
        border-color: #515971;
    }

    &:focus {
        border-width: 1.5px;
        border-color: #3059f0;
    }

    &::placeholder {
        color: #a8acb8;
    }
`;

export const RadioWrapper = styled.div<{ active?: boolean }>`
    box-sizing: border-box;
    height: 60px;
    width: 100%;
    padding: 15px 16px;
    line-height: 30px;

    border: 1px solid #9297a6;
    border-radius: 2px;
    outline: none;

    font-size: 16px;
    font-weight: 600;
    padding-left: 68px;

    background: url(${Radio}) no-repeat 36px center;

    ${({ active }) =>
        active &&
        css`
            background: url(${RadioActive}) no-repeat 36px center;
        `}
`;

export const CheckboxWrapper = styled.div`
    box-sizing: border-box;
    height: 60px;
    width: 100%;
    padding: 15px 16px;
    line-height: 30px;

    border: 1px solid #9297a6;
    border-radius: 2px;
    outline: none;

    display: flex;
    align-items: center;
    gap: ${Spacing.large};

    > input {
        height: 48px;
        width: 48px;
    }

    > div {
        font-size: ${FontSize.small};
        line-height: 130%;
        font-weight: 600;
    }
`;

export const ErrorMessage = styled.div`
    color: #f25b3a;
    font-size: ${FontSize.medium};

    display: flex;
    align-items: center;

    &::before {
        content: '';
        width: 18px;
        height: 18px;
        display: inline-block;
        background: url(${Error}) no-repeat center center;
        vertical-align: middle;
        margin-right: 4px;
    }
`;

export const FormErrorMessage = styled.div`
    color: #f25b3a;
    font-size: ${FontSize.medium};
    text-align: center;
`;

export const GoogleButton = styled.button`
    width: 100%;
    line-height: 60px;

    border: 1.5px solid #4970ff;
    border-radius: 2px;

    background: #f0f4ff;
    color: #262f4d;
    font-size: ${FontSize.x_large};
    text-decoration: none;
    cursor: pointer;

    display: flex;
    text-align: center;
    justify-content: center;
`;

export const GoogleLogo = styled.div`
    align-self: center;
    background: url(${GoogleImg}) no-repeat center center;
    background-size: contain;

    height: 25px;
    width: 25px;
    margin-right: 23px;
`;

export const Separator = styled.div`
    width: 100%;
`;

export const Lines = styled.div`
    display: flex;
    align-items: center;
    user-select: none;

    &::after,
    &::before {
        content: '';
        height: 1px;
        background: #a8acb8;
        display: block;
        flex: 1 1 auto;
    }
`;

export const Text = styled.div`
    color: #a8acb8;
    font-size: ${FontSize.large};
    padding: 0 20px;
`;

export const Link = styled.a`
    cursor: pointer;
    display: inline-block;

    color: #236bfa;
    font-size: ${FontSize.x_large};
    font-weight: 400;
    line-height: 20px;
    overflow-wrap: anywhere;
    text-decoration: none;

    &:visited {
        color: #236bfa;
    }
`;

export const SwitchPage = styled.div`
    display: flex;
    gap: ${Spacing.xxx_small};
    color: #999999;
    font-size: ${FontSize.large};
    font-weight: 300;
    line-height: 150%;
    padding: ${Spacing.medium};

    > ${Link} {
        font-size: ${FontSize.large};
        white-space: nowrap;
    }
`;
